import { isDevOrLocalhost } from "@/basa/utils";

/***
 * 全局判断配置中心
 * ***/
const CONFIG = {
  parentId: isDevOrLocalhost() ? "100001" : "100002", // 配置组织根节点id
  duration: 3000, //后端返回错误提示框自动关闭事件 0为不自动关闭
  requestDuration: 1000, //拒绝前端连续请求 间隔为1s
  axiosTimeOut: 60000, //axios超时时间
  isMenuMock: true //是否适用mock菜单
};

export default CONFIG;
export let commonTableWidth = {
  serialNoWidth: 50, //序号
  checkboxWidth: 55, //复选框
  telWidth: 110, //手机号
  dateWidth: 150, // 年月日时间宽度
  dateTimeWidth: 170, // 年月日时分秒时间宽度
  unitName: 200, // 单位
  supplierName: 200 // 供应商名称
};
export let pageTableWidth = {
  dateWidth: 150, // 年月日时间宽度
  dateTimeWidth: 170 // 年月日时分秒时间宽度
};
export let opCloWidth = {
  purchaseschemeCompileList: 220, // 方案编制列表操作宽度
  approvalQueryList: 50, // 方案审批列表操作宽度
  purchaseSchemeConfirmList: 50, // 方案确认列表操作宽度
  agreementMaintainList: 220 //  框架协议维护列表操作宽度
};
// 采购方案表格宽度统一配置
export let schemeColWidth = {
  schemeCode: 200, //设备物资编码
  schemeName: 150 // 设备物资名称
};

//设备物资表格列宽度
export let codePlatColWidth = {
  matcodeNum: 120, //设备物资编码
  matcodeName: 220 // 设备物资名称
};

//框架协议表格列宽度
export let agrColWidth = {
  matcodeName: 380, //协议编号
  protocolName: 200 //协议名称
};
//任务表格列宽度
export let taskColWidth = {
  taskCode: 200 //任务编号
};
// 详情页样式控制器
export let detailDomStyle = {
  style01: "detail-box ccui-clearfix", // 有右侧 有底部
  style02: "detail-box2 ccui-clearfix", // 有右侧 无底部
  style03: "detail-box3 ccui-clearfix", // 没有右侧 有底部
  style04: "detail-box4 ccui-clearfix" // 没有右侧 无底部
};
export let operState = {
  1: "approving",
  2: "approvaled"
};
export let schemeOperState = {
  1: "approving",
  2: "unapproval",
  3: "approvaled",
  4: ""
};
export let taskOperState = {
  1: "approving",
  2: "unapproval",
  3: "approvaled",
  4: ""
};
export let announcementPageSource = {
  notice: "1", //通知公告
  dynamicWork: "2", //工作动态
  evaluationResults: "3", //评标结果
  purchaseAnnouncement: "4", //采购公告
  marketDynamic: "5", //市场动态
  priceInfo: "6", //价格信息
  supplierRecommend: "7", //湖北供应商推荐
  overseasZone: "8", // 海外集采价格专区
  procurementBidding: "9", // 采购招标
  tenderInformation: "10", // 采购公告
  bidAnnouncement: "11", // 评标公示
  JCCG: "12", // 集采成果
  JGFA: "13", // 集采方案
  JCKJXY: "14", // 集采框架协议
  WZJCML: "15", // 物资集采目录
  JCZJCYMD: "16", // 集采专家成员名单
  CGGLZD: "17", // 采购管理制度
  SFWB: "18", // 示范文本
  NMQYXX: "19", // 内贸企业信息
  HJQK: "20", // 获奖情况
  JTGYSML: "21", // 集团供应商目录
  ZCFG: "22", // 政策法规
  ZDLC: "23", // 制度流程
  HTFB: "24", // 合同范本
  ZSGL: "25", // 知识管理
  GLTX: "26", // 管理体系
  HYWZ: "27", // 行业网站
  GYLGLBZJLXX: "28", // 供应链管理部总经理信箱
  exchangeForum: "29", // 交流论坛
  HYXW: "30", // 行业新闻
  SCHQ: "31", // 市场行情
  JGXX: "32", // 价格信息
  FXBG: "33" // 分析报告
};
export let marketCynamicAndPriceInfoURL = {
  marketDynamicUrl: "/apis/pp/users/signup/thirdParty/getThirdPartyInfo?",
  priceInfoUrl:
    "/apis/pp/users/signup/thirdParty/getThirdPartyInfo?interfaceType=1"
};
